import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // Close dropdown when clicking outside
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
  }

  toggle(event) {
    event.stopPropagation()
    
    // Close all other team action dropdowns
    document.querySelectorAll('[data-controller="team-actions"] [data-team-actions-target="menu"]').forEach(menu => {
      if (menu !== this.menuTarget) {
        menu.classList.add("hidden")
      }
    })
    
    // Toggle this dropdown
    this.menuTarget.classList.toggle("hidden")
    
    // Position dropdown to avoid cutoff
    if (!this.menuTarget.classList.contains("hidden")) {
      this.positionDropdown()
    }
  }

  positionDropdown() {
    const button = this.element.querySelector('button')
    const menu = this.menuTarget
    const buttonRect = button.getBoundingClientRect()
    const menuHeight = menu.offsetHeight
    const viewportHeight = window.innerHeight
    
    // Check if there's enough space below
    const spaceBelow = viewportHeight - buttonRect.bottom
    const spaceAbove = buttonRect.top
    
    // Reset classes
    menu.classList.remove("bottom-8", "top-8")
    
    if (spaceBelow < menuHeight + 20 && spaceAbove > menuHeight) {
      // Position above the button
      menu.classList.add("bottom-8")
    } else {
      // Position below the button (default)
      menu.classList.add("top-8")
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }
}